import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-suguyaku-oem-header',
  templateUrl: './suguyaku-oem-header.component.html',
  styleUrls: ['./suguyaku-oem-header.component.css'],
})
export class SuguyakuOemHeaderComponent implements OnChanges {
  imgpath: string;

  @Input()
  clientId: string;

  ngOnChanges(changes: SimpleChanges): void {
    this.imgpath = environment.apps[this.clientId].oemConfig?.imgpath;
  }
}
